export default __webpack_public_path__ + "static/media/invoice.6603938c.png";